import { IconNameEnum, useModuleBEM } from "@b2bportal/core-themes";
import { useI18nContext } from "@hopper-b2b/i18n";
import { Icon } from "@tenant/ui";
import styles from "./FlightInsuranceCancellationBanner.module.scss";

export const FlightInsuranceCancellationBanner = () => {
  const [block, cn] = useModuleBEM(styles, "FlightInsuranceCancellationBanner");
  const { t } = useI18nContext();

  return (
    <div className={block}>
      <div className={cn("content")}>
        <Icon iconName={IconNameEnum.warningTriangle} className={cn("icon")} />
        <div className={cn("text-content")}>
          <h3 className={cn("title")}>
            {t("trips.insuranceCancellation.title")}
          </h3>
          <p className={cn("body")}>{t("trips.insuranceCancellation.body")}</p>
        </div>
      </div>
    </div>
  );
};
